import { render, staticRenderFns } from "./Roadmaps.vue?vue&type=template&id=553eee1d&"
import script from "./Roadmaps.vue?vue&type=script&lang=js&"
export * from "./Roadmaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports